import React, { useState } from "react";

function AdBlock({ title, hasMobile = true }) {
  const defaultDesktop =
    '<IFRAME SRC="https://rtr.innovid.com/html/r1.6863f5a6969668.68434490?cb=%%CACHEBUSTER%%&ivc_click_through=%%CLICK_URL_ESC%%&iv_brand=jul2025_CVS" WIDTH=1040 HEIGHT=100 MARGINWIDTH=0 MARGINHEIGHT=0 HSPACE=0 VSPACE=0 FRAMEBORDER=0 SCROLLING=no BORDERCOLOR="#000000" browsingTopics></IFRAME>';
  const defaultMobile =
    '<IFRAME SRC="https://rtr.innovid.com/html/r1.6863f5a67f1036.55146877?cb=%%CACHEBUSTER%%&ivc_click_through=%%CLICK_URL_ESC%%&iv_brand=jul2025_CVS" WIDTH=300 HEIGHT=100 MARGINWIDTH=0 MARGINHEIGHT=0 HSPACE=0 VSPACE=0 FRAMEBORDER=0 SCROLLING=no BORDERCOLOR="#000000" browsingTopics></IFRAME>';

  const [desktopTag, setDesktopTag] = useState(defaultDesktop);
  const [mobileTag, setMobileTag] = useState(hasMobile ? defaultMobile : "");
  const [copied, setCopied] = useState(false);

  const scriptContent =
    "var desktopTag = '" +
    desktopTag +
    "';\n" +
    (hasMobile && mobileTag.trim()
      ? "var mobileTag = '" + mobileTag + "';"
      : "");

  const outputCode =
    '<a href="javascript:void(0);" onClick="window.open(clickTag,\'_top\');">\n' +
    '  <div id="CVSmain"></div>\n' +
    "  <script>\n" +
    scriptContent +
    "\n  </script>\n" +
    '  <script src="https://cdn.clinch.co/a_js/clientsCustomCode/cvs/clinchCvsOnsite.js"></script>\n' +
    "</a>";

  const handleCopy = () => {
    navigator.clipboard.writeText(outputCode).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleClear = () => {
    setDesktopTag("");
    if (hasMobile) setMobileTag("");
  };

  const handleReset = () => {
    setDesktopTag(defaultDesktop);
    if (hasMobile) setMobileTag(defaultMobile);
  };

  return (
    <div
      style={{
        marginBottom: "2rem",
        padding: "1rem",
        border: "1px solid #ccc",
        borderRadius: "8px",
      }}
    >
      <h2>{title}</h2>

      {/* Input Boxes */}
      <div style={{ marginBottom: "1rem" }}>
        <label>Desktop Iframe:</label>
        <textarea
          rows="3"
          style={{ width: "100%", marginBottom: "0.5rem" }}
          value={desktopTag}
          onChange={(e) => setDesktopTag(e.target.value)}
        />

        {hasMobile && (
          <>
            <label>Mobile Iframe (optional):</label>
            <textarea
              rows="3"
              style={{ width: "100%", marginBottom: "0.5rem" }}
              placeholder="Leave empty to remove mobileTag"
              value={mobileTag}
              onChange={(e) => setMobileTag(e.target.value)}
            />
          </>
        )}

        {/* Control Buttons */}
        <div style={{ marginTop: "0.5rem" }}>
          <button onClick={handleClear} style={{ marginRight: "0.5rem" }}>
            ❌ Clear
          </button>
          <button onClick={handleReset}>🔄 Reset</button>
        </div>
      </div>

      {/* Output */}
      <h3>Generated Code:</h3>
      <pre
        style={{
          background: "#f4f4f4",
          padding: "1rem",
          border: "1px solid #ddd",
          whiteSpace: "pre-wrap",
        }}
      >
        {outputCode}
      </pre>

      {/* Copy Button */}
      <button onClick={handleCopy} style={{ marginTop: "0.5rem" }}>
        📋 Copy Code
      </button>
      {copied && (
        <span style={{ marginLeft: "10px", color: "green" }}>✅ Copied!</span>
      )}
    </div>
  );
}

export default function InnovidAll() {
  return (
    <div>
      <AdBlock title="Leaderboard (1280x100)" />
      <AdBlock title="Anchor (1280x300)" />
      <AdBlock title="Skyscraper (240x620)" hasMobile={false} /> {/* 🚀 No mobile tag */}
      <AdBlock title="Interrepter (1040x100)" />
    </div>
  );
}
